import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Heading, SSOButton, Text } from '@redriverpress/system'

import Loc from '../common/components/Loc'
import {
  setSocialSso,
  useStudentOnboardingContext,
} from '../context/onboardingStudentContext'
import BottomLink from '../common/components/BottomLink'
import StudentLoginForm from '../common/components/StudentLoginForm'

export default function SignIn() {
  const { pathname: routePathname } = useLocation()
  const [
    { cleverSsoUrl, googleSsoUrl, locale },
    dispatch,
  ] = useStudentOnboardingContext()

  useEffect(() => {
    dispatch(setSocialSso(null))
  }, [routePathname])

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      minHeight='90vh'
      textAlign='center'
    >
      <Heading
        as='h1'
        styledAs='h2'
        mb={locale ? 0 : [3, null, 4]}
        mt={[4, null, null, 5]}
      >
        Ellii student login page
      </Heading>
      {!!locale && (
        <Loc
          fontSize={1}
          color='gray700'
          fontWeight='600'
          copy='Ellii Student Login Page'
          mb={[3, null, 4]}
        />
      )}

      <Box
        mt={[2, null, 3, 4]}
        display={['block', null, null, 'flex']}
        flexDirection={['unset', null, null, 'row']}
        width={[1, null, '70%', '50%']}
      >
        {/* Google */}
        <Box
          display='flex'
          flexDirection='column'
          flex={1}
          mr={[0, null, null, 1]}
          mb={[2, null, null, 0]}
        >
          <SSOButton
            as='a'
            type='Google'
            url={`${googleSsoUrl}&origin=sign_in`}
          >
            Log in with Google
          </SSOButton>
          {!!locale && (
            <Loc
              fontSize={0}
              color='gray700'
              fontWeight='400'
              copy='Log in with Google'
            />
          )}
        </Box>

        {/* Clever */}
        <Box
          display='flex'
          flexDirection='column'
          flex={1}
          ml={[0, null, null, 1]}
        >
          <SSOButton
            as='a'
            type='Clever'
            url={`${cleverSsoUrl}&origin=sign_in`}
          >
            Log in with Clever
          </SSOButton>
          {!!locale && (
            <Loc
              fontSize={0}
              color='gray700'
              fontWeight='400'
              copy='Log in with Clever'
            />
          )}
        </Box>
      </Box>

      {/* ------------- Divider ------------- */}
      <Box
        my={3}
        display='flex'
        alignItems='center'
        width={[1, null, '70%', '50%']}
      >
        <Box height='2px' bg='gray300' flex='1' />
        <Text px={2} fontWeight='600'>
          or
        </Text>
        <Box height='2px' bg='gray300' flex='1' />
      </Box>

      <StudentLoginForm />

      <BottomLink />
    </Box>
  )
}
